import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'primereact/button';
import { isAuthenticated } from '../services/auth/authenticator';
import AppTopbarMenu from './AppTopbarMenu';
import GrowAccountsCounter from './GrowAccountsCounter';

// eslint-disable-next-line react/no-multi-comp
class AppTopbar extends Component {
  static propTypes = {
    onToggleMenu: PropTypes.func.isRequired,
    accountId: PropTypes.string.isRequired,
  };

  render() {
    const { onToggleMenu, accountId } = this.props;
    const authenticated = isAuthenticated();
    return (
      <div className="layout-topbar clearfix">
        {authenticated && (
          <Button
            type="button"
            id="hide-menu-button"
            className="p-link layout-menu-button p-button-secondary"
            icon="pi pi-angle-left"
            onClick={onToggleMenu}
          />
        )}
        <div className="layout-topbar-icons">
          <div className="flex-space-between gap-2">
            {accountId && <GrowAccountsCounter accountId={accountId} />}
            <AppTopbarMenu accountId={accountId} />
          </div>
        </div>
      </div>
    );
  }
}

export default AppTopbar;
